import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useFuturesQuery } from '../../hooks/useFuturesQuery';
import { Container, Tab, Tabs, withStyles, makeStyles } from '@material-ui/core';
import Overflow from 'react-overflow-indicator';

import { styles } from './FuturesStyles';
import { PageTitle } from '../PageTitle';
import { useFutureDetailsQuery } from '../../hooks/useFutureDetailsQuery';
import { useConfigQuery } from '../../hooks/useConfigQuery';
import ChevronRight from './images/chevron_right.png';
import ChevronLeft from './images/chevron_left.png';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';
import { SportsBookLinks } from '../../utils/gameUtils';
import { SportsBook } from '../odds/SportsBook';
import { TwoWayValue } from '../oddsList/OddsValue';
import { TeamImage } from '../odds/TeamImage';
import ErrorView from '../../components/errors/ErrorView';
import { TwoValue } from '../TwoValue';

export const Futures = () => {
	const classes = styles();
	const history = useHistory();
	const scrollPane = useRef();
	const leftHeading = useRef();
	const { league, slug } = useParams();
	const { isLoading, futures, isError: isFuturesListError } = useFuturesQuery(league);
	const { isError, isLoading: futureDeailLoading, futureDetails } = useFutureDetailsQuery(slug || futures[0]?.slug);
	const { isLoading: configLoading, availableSportsBooks } = useConfigQuery();
	const [newBooks, setNewBooks] = useState([]);
	const [sortedFutures, setSortedFutures] = useState([]);
	const [showShadow, setShowShadow] = useState(false);

	useEffect(() => {
		if (window.innerWidth < 600) {
			window.addEventListener('scroll', (event) => {
				if (event.target.scrollingElement.scrollTop > 129) {
					setShowShadow(true);
				} else {
					setShowShadow(false);
				}
			});
			return () => {
				window.removeEventListener('scroll', () => {});
			}
		}
	}, []);

	useEffect(() => {
		if (!slug && futures && futures.length) {
			if (futures.findIndex(f => f.name.includes('Super Bowl')) > -1) {
				history.push(`/${league}/futures-odds/${futures.find(f => f.name.includes('Super Bowl'))?.slug}`);
			} else {
				history.push(`/${league}/futures-odds/${futures[0].slug}`);
			}
		}
		let newFutures = [];
		futures.forEach(f => {
			if (f.name.includes('Super Bowl')) {
				newFutures.push(f);
			}
		});
		futures.forEach(f => {
			if (f.name.includes('AFC')) {
				newFutures.push(f);
			}
		});
		futures.forEach(f => {
			if (f.name.includes('NFC')) {
				newFutures.push(f);
			}
		});
		futures.forEach(f => {
			if (newFutures.findIndex(n => n.name === f.name) === -1) {
				newFutures.push(f);
			}
		});
		setSortedFutures(newFutures);
	}, [futures]);

	useEffect(() => {
		if (futureDetails && futureDetails.competitors && availableSportsBooks.length) {
			let tempSportsBooks = [];
			let emptySportsBooks = [];
			availableSportsBooks.forEach(book => {
				const newBook = book === 'BetRivers' ? 'SugarHouseNJ' : book;
				for (let c of futureDetails.competitors) {
					let books = c.books.map(b => b.name);
					if (books.includes(newBook)) {
						tempSportsBooks.push(book);
						break;
					}
				}
				if (!tempSportsBooks.includes(book)) {
					emptySportsBooks.push(book);
				}
			});
			setNewBooks(tempSportsBooks.concat(emptySportsBooks));
		}
	}, [futureDetails, availableSportsBooks]);

	const changeSlug = (value) => {
		history.push(`/${league}/futures-odds/${value}`);
	}

	const isSelected = (filter) => {
		return filter === (slug || futures[0]?.slug) ? classes.selected : "";
	}

	if (isError || isFuturesListError) {
		return <ErrorView />
	}

	const handleScroll = (direction) => {
		const rhsWidth = scrollPane.current.node.clientWidth - leftHeading.current.clientWidth;
		if (direction === 'right') {
			scrollPane.current.node.scrollLeft += rhsWidth;
		} else {
			scrollPane.current.node.scrollLeft -= rhsWidth;
		}
	};

	return (
		<>
			<Container className={classes.contentContainer}>
				<PageTitle title={`${futureDetails?.name || ''}`} />
				{
					futures && futures.length > 0 &&
					<FuturesTabs 
						className={classes.tabs} value={slug || futures[0].slug}
						variant={'scrollable'}
						onChange={(e, newValue) => changeSlug(newValue)}
					>
						{
							sortedFutures.map(future => (
								<StyledTab key={future.slug} value={future.slug} label={future.short || future.name} className={isSelected(future.slug)} />
							))
						}
					</FuturesTabs>
				}
				<Overflow>
					{
						availableSportsBooks.length ?
						<div className={classes.stickyDiv}>
							<div className={classes.chevronDiv}>
								<Overflow.Indicator direction="left">
									<img alt="overflow left indicator" className={classes.chevronLeft} src={ChevronLeft} onClick={() => handleScroll('left')} />
								</Overflow.Indicator>
								<Overflow.Indicator direction="right">
									<img alt="overflow right indicator" className={classes.chevronRight} src={ChevronRight} onClick={() => handleScroll('right')} />
								</Overflow.Indicator>
							</div>
						</div> : null
					}
					<div className={classes.stickyGameDateDiv}>
						<div className={classes.gameDateAbsoluteDiv} ref={leftHeading}>
							<div className={`${classes.heading} ${classes.gameDateHeader}`}>
								<div className={classes.teamHeader}>Team</div>
								{/* <div className={classes.openHeader}>Open</div> */}
							</div>
						</div>
					</div>
					<ScrollSync>
						<div className={classes.table}>
							<div className={`${classes.header} ${showShadow ? classes.shadow : ''}`}>
								<ScrollSyncPane ref={scrollPane}>
									<Overflow.Content>
										<div className={`${classes.row} ${classes.headerRow}`}>
											<div className={`${classes.leftCol}`}></div>
											{
												newBooks.map((name) => (
													<div key={name}>
														<div className={classes.heading}>
															<a href={SportsBookLinks[name]} target="_blank" rel="noreferrer">
																<SportsBook name={name} />
															</a>
														</div>
													</div>
												))
											}
										</div>
									</Overflow.Content>
								</ScrollSyncPane>
							</div>

							<ScrollSyncPane>
								<div className={classes.items}>
									<Competitors league={league} competitors={futureDetails?.competitors} sportsBooks={newBooks} />
								</div>
							</ScrollSyncPane>
						</div>
					</ScrollSync>
				</Overflow>
			</Container>
		</>
	);
}

const Competitors = ({league, competitors, sportsBooks}) => {
	const styles = makeStyles(theme => ({
		rowContainer: {
			position: 'relative',
			[theme.breakpoints.down('sm')]: {
				display: 'inline-block',
			},
		},
		row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(280px, 280px)',
			gridAutoFlow: 'column',
			gridAutoColumns: 108,
			'-webkit-overflow-scrolling': 'touch',
			'&::-webkit-scrollbar': {
				display: 'none'
			},
			[theme.breakpoints.down('1280')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 9)',
			},
			[theme.breakpoints.down('1180')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 8)',
			},
			[theme.breakpoints.down('1080')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 7)',
			},
			[theme.breakpoints.down('980')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 6)',
			},
			[theme.breakpoints.down('880')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 5)',
			},
			[theme.breakpoints.down('780')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 4)',
			},
			[theme.breakpoints.down('680')]: {
				gridAutoColumns: 'calc((100vw - 280px) / 3)',
			},
			[theme.breakpoints.down('xs')]: {
				gridTemplateColumns: 'minmax(144px, 144px)',
				gridAutoColumns: 'minmax(94px,1fr)',
			},
			background: 'linear-gradient(90deg, rgba(196, 196, 196, 0.37) 0%, rgba(196, 196, 196, 0) 2.37%)',
		},
		col: {
			"& p": {
				textAlign: 'center'
			},
			borderBottom: '1px solid #E5E5E5',
		},
		teamMatchup: {
			display: 'flex',
			alignItems: 'center',
			position: 'sticky',
			left: 0,
			borderBottom: '1px solid #E5E5E5',
			zIndex: 1,
			backgroundColor: 'white',
			boxShadow: '4px 1px 5px -2px rgb(196 196 196 / 37%)',
			borderRight: '1px solid rgb(196 196 196 / 37%)',
			fontSize: 16,
			fontWeight: 600,
			minHeight: 52,
			color: '#000',
			[theme.breakpoints.down("xs")]: {
				fontSize: 12,
				minHeight: 33,
				fontWeight: 700,
			},
		},
		valueContainer: {
			width: 70,
			borderRadius: 8,
			border: '1px solid #D1CFD7',
			height: 24,
			position: 'relative',
			margin: '6px auto',
			"& p": {
				color: 'black !important',
			},
			[theme.breakpoints.up("sm")]: {
				borderRadius: 3,
				height: 30,
				width: 96,
				margin: '10px auto',
			},
			"& a": {
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				color: '#272f3e',
				fontWeight: 400,
			},
			"& a:hover": {
				backgroundColor: '#eeeeff',
				borderColor: '#eeeeff',
			},
			"& a:active": {
				backgroundColor: '#074589',
				borderColor: '#074589',
				color: '#ffffff',
				fontWeight: 700,
				"& p": {
					color: 'white',
					fontWeight: 'bold'
				}
			}
		},
		teamImage: {
			width: 30,
			height: 20,
			objectFit: 'contain',
			marginRight: 15,
			[theme.breakpoints.down("xs")]: {
				width: 20,
				marginRight: 10,
			},
		}
	}));
	const classes = styles();

	return competitors ? competitors.map(c => (
		<div className={classes.rowContainer} key={c.name}>
			<div className={`${classes.row} ${classes.oddsRow}`}>
				<div className={`${classes.teamMatchup}`}>
					<TeamImage className={classes.teamImage} competitor={c} league={league} />
					{c.name}
				</div>
				{
					sportsBooks.map((book, id) => (
						<div className={`${classes.col} `} key={`${book}_${id}`}>
							{
								c.books && c.books.find(b => b.name === (book === 'BetRivers' ? 'SugarHouseNJ' : book))?.odds &&
								<div className={classes.valueContainer}>
									<a href={SportsBookLinks[book]} target="blank">
										<TwoValue secondValue={c.books.find(b => b.name === (book === 'BetRivers' ? 'SugarHouseNJ' : book)).odds} />
									</a>
								</div>
							}
						</div>
					))
				}
			</div>
		</div>
	)) : null;
}

const StyledTab = withStyles((theme) => ({
	root: {
		minWidth: 70,
		padding: 0,
		marginRight: 10,
		fontFamily: 'proxima-nova',
		color: 'black',
	},
}))(Tab);

const FuturesTabs = withStyles((theme) => ({
	root: {
		position: 'sticky',
		top: 95,
		backgroundColor: 'white',
		zIndex: 18,
	}
}))(Tabs);